import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../../services/apiCalls";
import PortalLogo from "./../../../assets/images/portal-v3-icon.png";
import useUserStore from "../../../utils/storeApp";
import $ from "jquery";
import { jwtDecode } from "jwt-decode";
import {
  useIdentityServer,
  getUserRole,
  getUserSession,
  getDefaultLandingPage,
} from "../../../services/authorizationService";

const Login = () => {
  const { setUserRole, setUserToken, SetSharedObject, setUserSession } =
    useUserStore((state) => ({
      setUserRole: state.setUserRole,
      setUserToken: state.setUserToken,
      SetSharedObject: state.SetSharedObject,
      setUserSession: state.setUserSession,
    }));

  const [showPassword, setShowPassword] = useState(false);
  const [flag, setFlag] = useState(false);
  const [errFlag, setErrFlag] = useState(false);
  const [errFlagCred, setErrFlagCred] = useState(false);
  const [forgotFlag, setForgotFlag] = useState("");
  const [modalTxt, setModalTxt] = useState("");
  const [modalHeadTxt, setModalHeadTxt] = useState("");
  const [emailSent, setEmailSent] = useState(true);
  const [answers, setAnswers] = useState();
  const [processing, SetProcesing] = useState(false);
  const [processingModal, SetProcesingModal] = useState(false);
  const [errFlagBody, seterrFlagBody] = useState(false);
  const setAnswer = (questionId, answer) => {
    setAnswers({ ...answers, [questionId]: answer });
  };
  const navigate = useNavigate();
  const antiForgeryTokenElement = document.getElementById("AntiForgeryToken");

  useEffect(() => {
    if (flag) {
      navigate(flag, { replace: true });
    }

    // if using the open id connect login, see if there's currently an error generated
    // from identity server and injected into an element on the index page
    if (useIdentityServer) {
      const identityServerLoginErrorElement = document.getElementById(
        "IdentityLoginErrorPlaceholder"
      );
      if (
        identityServerLoginErrorElement &&
        identityServerLoginErrorElement.value
      ) {
        setErrFlag(identityServerLoginErrorElement.value);
      }
    }
  }, [flag, navigate]);

  const Login = async (el) => {
    el.preventDefault();
    SetProcesing(true);
    SetSharedObject(null);
    let msg = "";
    setErrFlag(false);
    localStorage.setItem("SystemError", "");
    let call = "/admin/Login";
    let bodyData = { username: answers.Username, password: answers.Password };
    const res = await CallAPI(call, bodyData, "post");
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let tokenJwt = jwtDecode(res.data.token);
      console.log(tokenJwt);
      setUserSession(tokenJwt);
      setUserToken(res.data.token);
      await getUsers(res.data.token);

      SetSharedObject("specialties", null);
      SetSharedObject("UserIdEmail", {});
      SetSharedObject("CustomerPermissionsObj", {});

      setUserRole(getUserRole(tokenJwt));
      setUserSession(getUserSession(tokenJwt));
      let navPage = getDefaultLandingPage(tokenJwt);

      if (navPage === "/webmail") {
        if (window !== "undefined") window.open("../webmail", "_self");
      } else {
        //navigate("/experian-sso");
        navigate(navPage);
      }

      SetProcesing(false);
    } else if (res.status === "SERVERERROR") {
      msg = "The Username and Password you entered does not match our records.";
      setErrFlag(msg);
      SetProcesing(false);
    } else if (res.status === "LOCKED") {
      msg =
        "Your account has been locked. Please contact your administrator for further assistance.";
      setErrFlag(msg);
      SetProcesing(false);
    }
  };

  const getUsers = async (token) => {
    SetProcesing(true);
    let call = "/users/GetUsersValues";
    const res = await CallAPI(call, false, "get", token);
    await SetSharedObject("ResponseCode", res.code);
    if (res && res.status === "SUCCESS") {
      SetSharedObject("vendorsObj", res.data.data.vendors);
      SetSharedObject("codes", res.data.data.codes);
      SetSharedObject("getOrgKinds", res.data.data.getOrgKinds);
      SetSharedObject("getOrgsObj", res.data.data.organizations);
      SetSharedObject("getUserEmails", res.data.data.emails);
      SetSharedObject("changePasswordFlag", false);
      SetProcesing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      setErrFlag(str);
      SetProcesing(false);
    }
  };

  const ForgotCred = (vl) => {
    seterrFlagBody(false);
    setErrFlagCred(false);
    if (vl === "username") {
      setModalTxt(
        "Your username will be sent to your valid contact email address we have on file associated with your account."
      );
      setModalHeadTxt("Forgot your username?");
      setForgotFlag("username");
    } else {
      setModalTxt(
        "If the username you entered is valid, you will receive password reset instructions to the email address we have on file."
      );
      setModalHeadTxt("Forgot your password?");
      setForgotFlag("password");
    }
    $("#ForgotCredId").modal("show");
  };

  const SendEmail = async (el) => {
    el.preventDefault();
    SetProcesingModal(true);
    setErrFlagCred(false);

    let call = "";
    if (forgotFlag === "username") {
      call = "/admin/ForgotUserName?email=" + answers.email;
    } else {
      call = "/admin/ForgotPassword?username=" + answers.Username;
    }
    const res = await CallAPI(call, false, "get");
    await SetSharedObject("ResponseCode", res.code);
    if (res && res.status === "SUCCESS") {
      if (forgotFlag === "username") {
        setModalTxt(
          "Username will be sent to your valid contact email address on file associated with your account."
        );
      } else {
        setModalTxt(
          "A password reset link has been sent to your contact email address on file with instructions on how to reset password. The link will expire in 24 hours."
        );
      }
      setModalHeadTxt("Email Sent");
      setEmailSent(false);
      SetProcesingModal(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "";
      for (let el of msg) {
        str += `${el}`;
      }

      setErrFlagCred(<div dangerouslySetInnerHTML={{ __html: str }} />);
      //$(".modal").modal("hide");
      SetProcesingModal(false);
    }

    //return;
    SetProcesingModal(false);
  };
  return (
    // <OidcSecure>
    <div className="Login">
      <section className="ses-loginwrapper" aria-labelledby="Login Container">
        <div className="ses-login-wrapper">
          <div className="ses-login-container">
            <form
              {...(useIdentityServer
                ? { action: `${window.location.href}`, method: "post" }
                : { onSubmit: (event) => Login(event) })}
            >
              {useIdentityServer ? (
                <input
                  type="hidden"
                  id="antiforgerytoken"
                  name={
                    antiForgeryTokenElement
                      ? antiForgeryTokenElement.name
                      : "antiforgerytoken"
                  }
                  value={
                    antiForgeryTokenElement
                      ? antiForgeryTokenElement.value
                      : "antiforgerytokenvalue"
                  }
                />
              ) : null}
              <div className="spacer-inline img-container">
                <img
                  src={PortalLogo}
                  className="filter-green"
                  alt="Portal Icon"
                />
              </div>
              <header>
                PORTAL
                {/*{<p className="card-text">{JSON.stringify(idToken)}</p>} */}
                {/* {isAuthenticated && (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => logout()}
                  >
                    logout
                  </button>
                )} */}
              </header>
              <div className="form-group">
                <label>Username</label>
                <input
                  id="Username"
                  name="Username"
                  type="text"
                  className="form-control"
                  size="35"
                  required
                  onChange={(el) => setAnswer("Username", el.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <div className="input-group mb-3">
                  <input
                    id="Password"
                    name="Password"
                    type={showPassword ? "text" : "password"}
                    className="form-control password-input"
                    size="35"
                    required
                    onChange={(el) => setAnswer("Password", el.target.value)}
                  />
                  <div className="input-group-append">
                    <button
                      className="input-group-text btn btn-secondary"
                      id="basic-addon2"
                      type="button"
                    >
                      {!showPassword ? (
                        <i
                          className="bi bi-eye-fill"
                          alt="Show Password Button"
                          title="Show Password Eye Icon"
                          onClick={() => setShowPassword(true)}
                        ></i>
                      ) : (
                        <i
                          className="bi bi-eye-slash-fill"
                          alt="Hide Password Button"
                          title="Hide Password Eye Icon"
                          onClick={() => setShowPassword(false)}
                        ></i>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <button type="submit" to="" className="btn btn-success">
                  Sign In
                </button>
              </div>
              <div className="form-group sp-mx sp-pad6">
                <div className="forgotUserPswd">
                  <div className="spacer-inline">
                    <a
                      href="#"
                      className="spacer-margin1"
                      data-backdrop="static"
                      data-keyboard="false"
                      name="showModal"
                      data-toggle="modal"
                      onClick={(e) => {
                        ForgotCred("username");
                        e.preventDefault();
                      }}
                    >
                      Forgot Username
                    </a>
                  </div>
                  <div className="wrapper spacer-inline">
                    <a
                      href="#"
                      data-backdrop="static"
                      name="forgotPswdModal"
                      onClick={(e) => {
                        ForgotCred("password");
                        e.preventDefault();
                      }}
                    >
                      Forgot Password
                    </a>
                  </div>
                </div>
              </div>
            </form>
            {/* Errors Messages */}
            {errFlag ? (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {errFlag}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section>

      <div
        className="modal fade"
        data-backdrop="static"
        id="ForgotCredId"
        data-keyboard="false"
        tabIndex="-1"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <form onSubmit={(event) => SendEmail(event)}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{modalHeadTxt}</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setEmailSent(true);
                    seterrFlagBody(false);
                  }}
                >
                  <span aria-hidden="false">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="descript2-container">{modalTxt}</div>
                {emailSent ? (
                  forgotFlag === "username" ? (
                    <div className="modal-content-form">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control form-sm"
                        size="35"
                        required
                        onChange={(el) => setAnswer("email", el.target.value)}
                      />
                    </div>
                  ) : (
                    <div className="modal-content-form">
                      <label>Username</label>
                      <input
                        type="text"
                        className="form-control form-sm"
                        size="35"
                        required
                        onChange={(el) =>
                          setAnswer("Username", el.target.value)
                        }
                      />
                    </div>
                  )
                ) : null}
                {errFlagBody ? (
                  <div className="ml-2">
                    <div className="alert alert-danger" role="alert">
                      {errFlagBody}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="modal-footer">
                {emailSent ? (
                  <button type="submit" className="btn btn-success btn-sm">
                    Send
                  </button>
                ) : null}
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  data-dismiss="modal"
                  onClick={() => {
                    setEmailSent(true);
                    seterrFlagBody(false);
                  }}
                >
                  Close
                </button>
                {errFlagCred ? (
                  <div className="alert alert-danger" role="alert">
                    {errFlagCred}
                  </div>
                ) : null}
              </div>

              {processingModal ? <div className="loading"></div> : null}
            </div>
          </form>
        </div>
      </div>
      {processing ? <div className="loading"></div> : null}
    </div>
    // </OidcSecure>
  );
};

export default Login;
